import dayjs from "dayjs";

import { StockAdjustmentTypeEnum } from "./stock-adjustment-form-constants";

/**
 * The request body for creating or editing a Penyesuaian Stok, from the form's values.
 * Shared by the form and by the file import, so a document made either way has the same shape.
 *
 * `formData.stockAdjustmentProductVariants` are `{ sku, type, quantity, costPerUnit, note }`, the
 * quantity always positive and the direction in `type`; the request carries a signed quantity.
 */
export const buildStockAdjustmentPayload = (formData, { editMode = false } = {}) => ({
  outletId: formData.outlet.id,
  warehouseId: formData.warehouse.id,
  // The API takes a master COA id and resolves this outlet's OCOA from it by
  // code. On edit the field holds the OCOA the server sent back, whose id is
  // not a COA id — and the input is locked anyway, so omit it and let the
  // server keep the account already on the document.
  ...(editMode
    ? {}
    : {
        adjustmentChartOfAccountId: formData.adjustmentChartOfAccount?.id ?? null,
      }),
  transactionDate: dayjs(formData.transactionDate).format("YYYY-MM-DD"),
  note: formData.note || null,
  stockAdjustmentProductVariants: formData.stockAdjustmentProductVariants.map(
    (line) => ({
      ...(editMode && line.id ? { id: line.id } : {}),
      sku: line.sku,
      quantity:
        line.type === StockAdjustmentTypeEnum.DEDUCTION
          ? -Math.abs(Number(line.quantity))
          : Math.abs(Number(line.quantity)),
      costPerUnit:
        line.type === StockAdjustmentTypeEnum.ADDITION
          ? Number(line.costPerUnit)
          : 0,
      note: line.note || null,
    })
  ),
});
